<template>
  <div class="placeable" @mouseover="show = true" @mouseout="show = false">
  <img  :src="containerImg()" @error="addDefaultSrc"/>
   <transition name="fade">
    <span v-if="show" class="tooltip"> 
      {{ placeable.name }}
      <br>
      {{ placeable.slot }}
      </span>
    </transition>
  </span>
  </div>
</template>

<script>
export default {
  name: 'Container',
  props: ['placeable'],
  data () {
    return {
      show: false,
      img: this.placeable.type + '.png'
    }
  },
  methods: {
    containerImg () {
      let type = this.placeable.type
      let url = 'https://s3.amazonaws.com/opentrons-images/website/labware/'
      if (type.includes('96')) { return url + '96-plate.png' }
      return url + type + '.png'
    },
    addDefaultSrc (e) {
      e.target.src = 'https://s3.amazonaws.com/opentrons-images/website/labware/custom.png'
    }
  }
}
</script>

<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
  }
  #img{
    color: white;
    font-size: 10px;
    padding-left: 10px;
  }
</style>


// WEBPACK FOOTER //
// Container.vue?092feabe